export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent';

const TONE_BY_STATUS: Record<string, Tone> = {
  VERIFIED: 'success',
  PAID: 'success',
  ISSUED: 'success',
  APPROVED: 'success',
  COMPLETED: 'success',
  CLEARED: 'success',
  MATCHED: 'success',
  LODGED: 'success',
  PUBLISHED: 'success',
  COMMITTED: 'success',
  QUOTED: 'success',
  ABN_QUOTED: 'success',
  EXEMPT: 'neutral',
  DONE: 'success',
  OPEN: 'info',
  RAISING: 'accent',
  SETUP: 'neutral',
  ACTIVE: 'info',
  CLOSED: 'neutral',
  WINDING_UP: 'warning',
  DRAFT: 'neutral',
  NOT_STARTED: 'neutral',
  INVITED: 'neutral',
  IN_PROGRESS: 'info',
  SUBMITTED: 'info',
  VERIFYING: 'info',
  IN_REVIEW: 'info',
  UPLOADED: 'info',
  MAPPED: 'info',
  COMPONENTS_IMPORTED: 'info',
  GENERATED: 'info',
  REVIEWED: 'info',
  VALIDATED: 'info',
  RECONCILED: 'info',
  SUGGESTED: 'accent',
  QUEUED: 'info',
  PRICED: 'info',
  WOUND_UP: 'neutral',
  AWAITING_INVESTOR: 'warning',
  REISSUED: 'success',
  UNCLAIMED: 'neutral',
  PENDING_APPROVAL: 'warning',
  PENDING: 'warning',
  AWAITING_FUNDS: 'warning',
  KYC_REVIEW: 'warning',
  PARTIAL: 'warning',
  UNPAID: 'warning',
  UNMATCHED: 'warning',
  REFER: 'warning',
  MEDIUM: 'warning',
  REPORTABLE: 'warning',
  NOT_QUOTED: 'danger',
  OVERDUE: 'danger',
  REJECTED: 'danger',
  FAILED: 'danger',
  EXPIRED: 'danger',
  ESCALATED: 'danger',
  HIGH: 'danger',
  LOW: 'neutral',
  IGNORED: 'neutral',
  WITHDRAWN: 'neutral',
  NOT_REPORTABLE: 'neutral',
};

export function toneFor(status: string): Tone {
  return TONE_BY_STATUS[status] ?? 'neutral';
}

export const TONE_COLORS: Record<Tone, { bg: string; fg: string; border: string }> = {
  neutral: { bg: '#F1F5F9', fg: '#334155', border: '#E2E8F0' },
  info: { bg: '#EFF6FF', fg: '#1D4ED8', border: '#BFDBFE' },
  success: { bg: '#ECFDF5', fg: '#047857', border: '#A7F3D0' },
  warning: { bg: '#FFFBEB', fg: '#B45309', border: '#FDE68A' },
  danger: { bg: '#FEF2F2', fg: '#B91C1C', border: '#FECACA' },
  accent: { bg: '#EEF2FF', fg: '#4338CA', border: '#C7D2FE' },
};

const LABELS: Record<string, string> = {
  PENDING_APPROVAL: 'Awaiting approval',
  AWAITING_FUNDS: 'Awaiting funds',
  KYC_REVIEW: 'KYC review',
  NOT_QUOTED: 'TFN not quoted',
  QUOTED: 'TFN quoted',
  ABN_QUOTED: 'ABN quoted',
  NOT_REPORTABLE: 'Not reportable',
  COMPONENTS_IMPORTED: 'Components imported',
  NOT_STARTED: 'Not started',
  IN_REVIEW: 'In review',
  IN_PROGRESS: 'In progress',
  QUEUED: 'Queued for window',
  WOUND_UP: 'Wound up',
  SETUP: 'In setup',
};

export function statusLabel(status: string): string {
  if (LABELS[status]) return LABELS[status];
  const lower = status.replace(/_/g, ' ').toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
